<template>
    <div class="project-container">
        <div class="row">
            <div class="left">
                <span>创建时间：</span>
                <el-date-picker v-model="startDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
                    placeholder="选择日期">
                </el-date-picker>
                <el-date-picker v-model="endDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
                    placeholder="选择日期">
                </el-date-picker>
            </div>
            <div class="right">
                <el-input placeholder="请输入内容" v-model="searchStr" class="input-with-select">
                    <el-select v-model="searchType" slot="prepend" placeholder="请选择">
                        <el-option label="项目名称" value="projectName"></el-option>
                        <el-option label="项目编号" value="projectNumber"></el-option>
                    </el-select>
                </el-input>
                <el-button icon="el-icon-search" type="primary" @click="getData">搜 索</el-button>
                <el-button type="primary" @click="initData">重 置</el-button>
            </div>
        </div>
        <el-button type="primary" @click="createProject" class="createBtn">创 建</el-button>
        <el-table :data="tableData" border style="width: 100%" max-height="780px" :header-cell-style="getTableHeader()"
            stripe v-loading="loadData">
            <el-table-column prop="explanation" label="费用说明" width="180" align="center">
            </el-table-column>
            <el-table-column prop="feeType" label="费用类型" width="180" align="center">
            </el-table-column>
            <el-table-column prop="nature" label="费用性质" width="180" align="center">
            </el-table-column>
            <el-table-column prop="wbsNumber" label="WBS编号" width="180" align="center">
            </el-table-column>
            <el-table-column prop="projectName" label="项目" width="180" align="center">
            </el-table-column>
            <el-table-column prop="projectNumber" label="项目编号" width="180" align="center">
            </el-table-column>
            <el-table-column prop="tradingTime" label="使用时间" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" @click="editRow(scope.row)">
                        查看
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="page-block">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
                :page-sizes="[10, 20, 50, 100, 200, 300, 500]" :page-size="size"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
        <el-dialog title="费用记录" :visible.sync="dialogVisible" width="80%" :before-close="handleClose">
            <div class="box">
                <div class="item w100">
                    <div class="label">费用说明</div>
                    <ElInputTrim v-model="baseInfo.explanation" type="textarea" rows="2" :disabled="!canEdit" />
                </div>
                <div class="row">
                    <div class="item w50">
                        <div class="label">费用类型</div>
                        <ElInputTrim v-model="baseInfo.feeType" :disabled="!canEdit" />
                    </div>
                    <div class="item w50">
                        <div class="label">费用性质</div>
                        <el-select v-model="baseInfo.nature" :disabled="!canEdit" placeholder="请选择" clearable>
                            <el-option label="即时" value="即时"></el-option>
                            <el-option label="账期" value="账期"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="row">
                    <div class="item w50">
                        <div class="label">费用金额<span class="required">*</span></div>
                        <ElInputTrim v-model="baseInfo.amount" type="number" :disabled="!canEdit" />
                    </div>
                    <div class="item w50">
                        <div class="label">WBS<span class="required">*</span></div>
                        <el-select v-model="baseInfo.wbsId" :disabled="!canEdit" placeholder="请选择" clearable
                            @change="wbsChange">
                            <el-option :label="item.wbsNumber" :value="item.id" :key="item.id"
                                v-for="item in wbsOpts"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="row">
                    <div class="item w50">
                        <div class="label">WBS名称</div>
                        <ElInputTrim v-model="baseInfo.wbsName" disabled />
                    </div>
                    <div class="item w50">
                        <div class="label">使用时间</div>
                        <el-date-picker v-model="baseInfo.tradingTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                            type="date" placeholder="选择日期" :disabled="!canEdit">
                        </el-date-picker>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="canEdit = true" v-if="dialogId && !canEdit">编 辑</el-button>
                <el-button type="primary" @click="submit" v-if="!dialogId || canEdit">保 存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getTableHeader } from '../../assets/js/common.js'
import { ajaxGet, ajaxPost, Baseurl } from '../../api/api/api.js';
import { mapState } from 'vuex';
import ElInputTrim from '@/components/ElInputTrim/index.vue';
export default {
    name: 'CostDetails',
    components: {
        ElInputTrim
    },
    props: {},
    data() {
        return {
            startDate: '',
            endDate: '',
            searchStr: '',
            searchType: 'projectName',
            page: 1,
            size: 10,
            total: 0,
            dialogVisible: false,
            canEdit: false,
            tableData: [],
            baseInfo: {
                explanation: '',
                feeType: '',
                nature: '',
                amount: '',
                wbsId: '',
                wbsName: '',
                tradingTime: ''
            },
            dialogId: null,
            wbsOpts: [],
            wbsMap: {},
            loadData: false,
        };
    },
    watch: {},
    computed: {
        ...mapState({
            role: state => state.user.role,
        })
    },

    created() {
        // this.endDate = this.formatDate(new Date().getTime());
        // this.startDate = this.endDate.substring(0, 7) + '-01';
        this.getWbsList(); //获取所有公司
    },
    mounted() {
        this.getData();
    },
    methods: {
        formatDate(timestamp) {
            const date = new Date(timestamp);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        editRow(d) {
            this.baseInfo = JSON.parse(JSON.stringify(d));
            this.dialogVisible = true;
            this.dialogId = d.id;
        },
        wbsChange() {
            const obj = this.wbsMap;
            this.$set(this.baseInfo, 'wbsName', obj[this.baseInfo.wbsId] ? obj[this.baseInfo.wbsId].wbsName : '');
        },
        getWbsList() {
            ajaxPost(Baseurl + 'projectWbsController/selectProjectWbsList').then((resp) => {
                if (resp.status === 200) {
                    const res = resp.data;
                    if (res.code === 200) {
                        const data = res.data;
                        const obj = {};
                        for(let i = 0; i < data.length; i++){
                            obj[data[i]['id']] = data[i];
                        }
                        this.wbsMap = obj;
                        this.wbsOpts = data;
                    } else {
                        this.$message.error(res.message)
                    }
                }
            })
        },
        initData() {
            this.startDate = '';
            this.endDate = '';
            this.searchStr = '';
            this.page = 1;
            this.size = 10;
            this.searchType = 'projectName';
            this.getData();
        },
        getData() {
            this.loadData = true;
            const params = {
                "page": this.page,
                "size": this.size,
                // "startTime": this.startDate + " 00:00:00",
                // "endTime": this.endDate + " 23:59:59",
            }
            if (this.startDate) {
                params['startTime'] = this.startDate + " 00:00:00"
            }
            if (this.endDate) {
                params['endTime'] = this.endDate + " 23:59:59"
            }
            if (this.searchStr) {
                params['searchType'] = this.searchType;
                params['searchStr'] = this.searchStr;
            }
            ajaxPost(Baseurl + 'projectCostController/selectProjectCostList', params).then((resp) => {
                if (resp.status === 200) {
                    const res = resp.data;
                    if (res.code === 200) {
                        const data = res.data;
                        this.tableData = data.list;
                        this.total = data.total;
                    } else {
                        this.$message.error(res.message);
                    }
                }
                this.loadData = false;
            })
        },
        // 基础信息保存
        async submit() {
            if (!this.baseInfo.amount){
                this.$message.error('费用金额不能为空！');
                return;
            }
            if (!this.baseInfo.wbsId) {
                this.$message.error('WBS不能为空！');
                return;
            }
            let wbsBalance = 0;
            const resp = await ajaxPost(Baseurl + 'projectWbsController/selectProjectWbsDetail', {id: this.baseInfo.wbsId});
            if (resp.data && resp.data.code === 200){
                wbsBalance = resp.data.data.balance;
            }
            if( +this.baseInfo.amount > wbsBalance) {
                this.$message.error('WBS余额不足！');
                return;
            }
            const params = {
                ...this.baseInfo,
            }
            let text = '新建';
            let api = 'insertProjectCost';
            if (this.dialogId) {
                params['id'] = this.dialogId;
                text = '修改';
                api = 'updateProjectCost'
            }
            ajaxPost(Baseurl + 'projectCostController/' + api, params).then((resp) => {
                if (resp.status === 200) {
                    const res = resp.data;
                    if (res.code === 200) {
                        // this.dialogId = res.data;
                        this.$message.success(text + '成功！');
                        this.dialogVisible = false;
                        this.clearDialogData();
                        this.getData();
                    } else {
                        this.$message.error(res.message);
                    }
                }
            })
        },
        clearDialogData() {
            this.dialogId = null;
            this.baseInfo = {};
            this.canEdit = false;
        },
        handleClose() {
            this.clearDialogData();
            this.dialogVisible = false;
        },
        getTableHeader,
        handleSizeChange(val) {
            this.page = 1;
            this.size = val;
            this.getData();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getData();
        },
        createProject() {
            this.canEdit = true;
            this.dialogVisible = true
        }
    },
};
</script>
<style lang="scss" scoped>
.row {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .left,
    .right {
        display: flex;
        align-items: center;
    }

    /deep/ .el-date-editor {
        margin: 0 5px;
    }

    .right {
        .el-button {
            margin-left: 10px;
        }

        .el-select {
            width: 120px;
        }
    }
}

.box {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    overflow: hidden;
    .row{
        width: 100%;
        display: flex;
        // justify-content: space-between;
    }

    .item {
        width: 30%;
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        justify-content: space-between;

        .label {
            width: 80px;
        }

        .el-input,
        .el-textarea,
        .value,
        .el-select,
        .el-date-editor {
            flex: 1;
            margin: 0;
        }

        &.w100 {
            width: 100%;
        }
        &.w50 {
            width: calc(50% - 10px);
        }
    }

    &.shop {
        display: block;

        .select-box {
            display: flex;

            .select-item {
                display: flex;
                align-items: center;
                margin-right: 10px;

                .select-label {
                    margin-right: 5px;
                }

                .el-select {
                    width: 250px;

                    &.w800 {
                        width: 800px;
                    }
                }
            }
        }
    }
}

/deep/ .el-tabs__content {
    max-height: 500px;
}

.el-tab-pane {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: auto;

    .editable-container {
        width: 100%;
    }

    

    .last-button {
        margin-top: 5px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}
.box {
    width: 100%;
    max-height: 465px;
}
.started {
    background-color: #70b603;
    color: #fff;
    padding: 0 5px;
    border-radius: 5px;
    display: inline-block;
}

.not-started {
    background-color: #f5f5f5;
    color: #999;
    padding: 0 5px;
    border-radius: 5px;
    display: inline-block;
}

.page-block {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
}

.createBtn {
    margin: 10px 0;
}
</style>